// extracted by mini-css-extract-plugin
module.exports = {"button":"SentryFeedbackButton_button__1VX4V"};